import { Component, OnInit, OnDestroy, ViewChild, HostListener, Inject, ElementRef, ViewEncapsulation, Injector, TemplateRef } from '@angular/core';
import { PageTitleService } from '../core/page-title/page-title.service';
import { ChkService } from '../service/chk.service';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from 'app/core/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'app/core/services/modal.service';
import { CartService } from 'app/core/services/cart.service';
declare var $ : any;

@Component({
    selector: 'angly-layout',
  	templateUrl:'./main.component.html',
  	styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit{

	 private _router: Subscription;
	 url: string;
	 private _mediaSubscription: Subscription;
	 private _routerEventsSubscription: Subscription;
	 isHome : boolean = true;
	 isBlog : boolean = false;
	 isCommon : boolean = false;
	 fixedHeaderClass : boolean = false;
	
	/* Variables */
	headerTitle    : string;
	headerSubTitle : string;
	featuredPost   : any;
	heading : string = '';
	imgSrc: string = '';


	public titleModal: string;
	public contentModal: string;
	public modalYesNo: boolean = true;

	public spinnerVisibile:string = "d-none";

	public yesModalCallback: (r:Router) => void;

	constructor(private pageTitleService: PageTitleService, private service:ChkService, private cartService: CartService,
		public router: Router, public authService: AuthenticationService, private injector: Injector, public modalService:ModalService) {
		/* page subTitle. */
			this.pageTitleService.subTitle.subscribe((val: string) => {
			this.headerSubTitle = val;
		});
		this.pageTitleService.title.subscribe((val: string) => {
			this.headerTitle = val;
		});
		this.service.getFeaturedPost().
			subscribe(response => {this.featuredPost = response},
			          err    => console.log(err),
			          ()     => this.featuredPost
			       );
	}
	
	private modal = this.injector.get(NgbModal);
	@ViewChild('modalContent')
	private modalContent: TemplateRef<any>;

	ngOnInit() { 
		this.cartService.checkCarrelloPresente();
	}
	
	@HostListener('scroll', ['$event'])
	onScroll(event) {
		  if(event.path && (event.path[0].scrollTop > 0)){
		  		this.fixedHeaderClass = true;
		  }else{
		  		this.fixedHeaderClass = false;
		  }
	}

	onActivate(e, scrollContainer) {
		scrollContainer.scrollTop = 0;
		window.scroll(0,0);
   }

   addToggleClass() {
   	$('body').toggleClass('rtl-enable');
   }

   public openModal() {
    
	this.modal.open(this.modalContent, { ariaLabelledBy: 'modal-basic-title' }).result.then(
		(result) => {
			
		},
		(reason) => {
			
		},
	);
}

	public closeModal() {

		this.modal.dismissAll();
	}

	public YesClick(fn: (r:Router) => void): any {
		fn(this.router);
		this.closeModal();
	}

	public showThrobber(){
		this.spinnerVisibile = "d-block";
	}

	public hideThrobber(){
		this.spinnerVisibile = "d-none";
	}
}
